import _ from "lodash";
import React, { createRef } from "react";
import classes from "./StudentLogin.scss";
import { GOOGLE_CLIENT_ID, LEX, LEX_PILOT } from "Constants";

import GoogleLoginBtn from "UIComponents/GoogleLoginBtn";
import MicrosoftLoginBtn from "UIComponents/MicrosoftLoginBtn";
import GridLayoutWrapper from "UIComponents/GridLayoutWrapper";
import CustomLoginButton from "UIComponents/CustomLoginButton";
import {FormTextInput} from "UIComponents/InputTextField";
import { Button, DropdownMenu } from "@toddle-edu/ds-web";

import ThirdPartyAuth from "AppComponents/ThirdPartyAuth";
import {
  CleverColored,
  ProfileOutlined,
  LexColored,
  MailColored,
  SchoolOutlined,
} from "@toddle-edu/ds-icons";
import classNames from "classnames";

const styles = {
  innerConStyle: {
    width: "auto",
  },
  containerStyle: {
    height: "48px",
    marginBottom: "0px",
  },
};

class StudentLogin extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showError: false,
    };

    this.inputRef = createRef(null);
  }

  isValid = value => {
    return _.trim(value).length > 0;
  };

  onLoginClick = () => {
    const {
      updateCurrentScreen,
      isNewLoginFlowEnabled,
      enableLoginFlowV2,
    } = this.props;
    updateCurrentScreen({
      type: enableLoginFlowV2
        ? "loginFormV3"
        : isNewLoginFlowEnabled
        ? "loginFormV2"
        : "loginForm",
    });
  };

  onBackClick = () => {
    const { updateCurrentScreen } = this.props;
    updateCurrentScreen({ type: "loginHome", paramsToBeRemoved: ["usertype"] });
  };

  updateInputField = value => {
    const { updateInputField } = this.props;
    const { showError } = this.state;

    if (showError && this.isValid(value)) this.setState({ showError: false });
    updateInputField({ code: value });
  };

  onSubmitClick = () => {
    const {
      signInUsingCode,
      data: { code },
      workspaceOrgId,
    } = this.props;

    this.inputRef?.isValid();
    if (this.isValid(code)) {
      signInUsingCode({ code, orgId: workspaceOrgId });
    } else {
      this.setState({ showError: true });
    }
  };

  updateCleverAuthRef = ref => {
    this.authCleverRef = _.get(ref, "refs.wrappedInstance", {});
  };

  updateLexAuthRef = ref => {
    this.authLexRef = _.get(ref, "refs.wrappedInstance", {});
  };

  updateLexPilotAuthRef = ref => {
    this.authLexPilotRef = _.get(ref, "refs.wrappedInstance", {});
  };

  onCleverLogInClick = () => {
    const { updateToddleInitiatedValue } = this.props;
    if (this.authCleverRef) {
      updateToddleInitiatedValue(true);
      this.authCleverRef.onAuthClick();
    }
  };

  onLexLoginClick = () => {
    const { updateToddleInitiatedValue } = this.props;
    if (this.authLexRef) {
      updateToddleInitiatedValue(true);
      this.authLexRef.onAuthClick();
    }
  };

  onLexPilotLoginClick = () => {
    const { updateToddleInitiatedValue } = this.props;
    if (this.authLexPilotRef) {
      updateToddleInitiatedValue(true);
      this.authLexPilotRef.onAuthClick();
    }
  };

  getLexOptions = () => {
    return [
      {
        key: LEX_PILOT,
        label: "Lex Global",
        icon: <LexColored size="xx-small" />,
      },
      {
        key: LEX,
        label: "Lex Brazil",
        icon: <LexColored size="xx-small" />,
      },
    ];
  };

  onClickLexOption = ({ key }) => {
    if (key === LEX_PILOT) {
      this.onLexPilotLoginClick();
    } else if (key === LEX) {
      this.onLexLoginClick();
    }
  };

  onYourSchoolClick = () => {
    const { updateCurrentScreen } = this.props;

    updateCurrentScreen({ type: "schoolCodeForm" });
  };

  render() {
    const {
      onGoogleSignInCallBack,
      onGoogelFailureCallBack,
      onMicroSoftSignInCallBack,
      onMicroSoftFailureCallBack,
      onCleverSignInCallBack,
      onLexSignInCallBack,
      onLexPilotSignInCallBack,
      renderTradeMarkText,
      customStyle: { headerStyleV2, subTextStyle } = {},
      inputStyle,
      renderBackButtonComponent,
      data: { code } = {},
      currentScreen,
      isCleverEnabled,
      isLexEnabled,
      isGoogleEnabled,
      isMicrosoftEnabled,
      isNewLoginFlowEnabled,
      isOrgWorkspaceLoginPage = false,
      loginButtonsCount,
      renderLoginMethods,
      isStudentSigninCodeLoginEnabled,
      isOrgWorkspaceLoginEnabled,
      organizationName,
      isOTPLoginEnabled,
      isPasswordLoginEnabled,
    } = this.props;

    const { showError } = this.state;

    const showHelperText = isOrgWorkspaceLoginPage
      ? loginButtonsCount > 0
      : isNewLoginFlowEnabled;

    const isEmailLoginFlowEnabled =
      (isOTPLoginEnabled || isPasswordLoginEnabled) && isNewLoginFlowEnabled;

    const containerStyle = {
      paddingTop: isOrgWorkspaceLoginPage ? "13%" : "19.5%",
    };

    return (
      <div
        className={classes.container}
        style={containerStyle}
        role="main"
        aria-label="Student Login Page"
      >
        <div>
          {renderBackButtonComponent({
            onClick: this.onBackClick,
            buttonText: isOrgWorkspaceLoginPage
              ? organizationName
              : "Toddle home",
            ariaLabel: "Go back to usertype selection screen",
          })}
          <div style={headerStyleV2}>
            {isOrgWorkspaceLoginPage
              ? "Sign in to your student account"
              : "Student account"}
          </div>
          <div
            className={classNames({
              [classes.buttonsContainer]: true,
              [classes.buttonsContainerV2]: isNewLoginFlowEnabled,
            })}
            role="group"
            aria-label="Login methods"
          >
            {showHelperText ? (
              <div className={classes.helperText}>{"Sign in with"}</div>
            ) : null}
            {!isOrgWorkspaceLoginPage ? (
              <GridLayoutWrapper
                noOfColumns={2}
                itemsPerRow={2}
                stretchItemsInLastRow={false}
                role="list"
                aria-label="Login options list"
              >
                {isEmailLoginFlowEnabled && (
                  <CustomLoginButton
                    key={"EMAIL_LOGIN_BTN"}
                    data-test-id={"button-login-email"}
                    icon={<MailColored size="x-small" />}
                    onClick={this.onLoginClick}
                    buttonText={"Email"}
                    innerConStyle={styles.innerConStyle}
                    containerStyle={styles.containerStyle}
                  />
                )}

                {isGoogleEnabled && (
                  <GoogleLoginBtn
                    key={"GOOGLE_LOGIN_BTN"}
                    clientId={GOOGLE_CLIENT_ID}
                    onSuccess={onGoogleSignInCallBack}
                    onFailure={onGoogelFailureCallBack}
                    prompt="select_account"
                    innerConStyle={styles.innerConStyle}
                    containerStyle={styles.containerStyle}
                  />
                )}

                {isMicrosoftEnabled && (
                  <MicrosoftLoginBtn
                    key={"MICROSOFT_LOGIN_BTN"}
                    onSuccess={onMicroSoftSignInCallBack}
                    onFailure={onMicroSoftFailureCallBack}
                    className={classes.buttonContainer}
                    innerConStyle={styles.innerConStyle}
                    containerStyle={styles.containerStyle}
                  />
                )}

                {isCleverEnabled && (
                  <CustomLoginButton
                    key={"CLEVER_LOGIN_BTN"}
                    data-test-id={"button-login-clever"}
                    icon={<CleverColored size="x-small" />}
                    onClick={this.onCleverLogInClick}
                    buttonText={"Clever"}
                    innerConStyle={styles.innerConStyle}
                    containerStyle={styles.containerStyle}
                  />
                )}

                {isLexEnabled && (
                  <CustomLoginButton
                    key={"LEX_LOGIN_BTN"}
                    data-test-id={"button-login-clever"}
                    icon={<LexColored size="x-small" />}
                    onClick={this.onLexLoginClick}
                    buttonText={"Lex"}
                    innerConStyle={styles.innerConStyle}
                    containerStyle={styles.containerStyle}
                    isSplitButton={true}
                    overlay={
                      <DropdownMenu
                        options={this.getLexOptions()}
                        onClick={this.onClickLexOption}
                      />
                    }
                  />
                )}

                {isOrgWorkspaceLoginEnabled && (
                  <CustomLoginButton
                    key={"SCHOOL_LOGIN_BTN"}
                    data-test-id={"button-login-school"}
                    icon={<SchoolOutlined size="x-small" />}
                    buttonText={"Your school"}
                    onClick={this.onYourSchoolClick}
                    innerConStyle={styles.innerConStyle}
                    containerStyle={styles.containerStyle}
                  />
                )}
              </GridLayoutWrapper>
            ) : (
              renderLoginMethods()
            )}
          </div>

          <ThirdPartyAuth
            serviceType="CLEVER"
            ref={this.updateCleverAuthRef}
            onSuccessCallBack={onCleverSignInCallBack}
          />
          <ThirdPartyAuth
            serviceType="LEX"
            ref={this.updateLexAuthRef}
            onSuccessCallBack={onLexSignInCallBack}
          />
          <ThirdPartyAuth
            serviceType="LEX_PILOT"
            ref={this.updateLexPilotAuthRef}
            onSuccessCallBack={onLexPilotSignInCallBack}
          />

          {isStudentSigninCodeLoginEnabled ? (
            <>
              {showHelperText ? (
                <div className={classes.orContainer}>
                  <div className={classes.orLineContainer} />
                  <div className={classes.orText}>or</div>
                  <div className={classes.orLineContainer} />
                </div>
              ) : null}

              <div className={classes.signInCodeContainer}>
                <div className={classes.signInText}>
                  {"Enter student sign-in code"}
                </div>
                <div className={classes.inputRowContainer}>
                  <div className={classes.inputField}>
                    <FormTextInput
                      ref={ref => (this.inputRef = ref)}
                      value={code}
                      size={"large"}
                      updateInputField={this.updateInputField}
                      onEnter={this.onSubmitClick}
                      placeholder={"Enter student sign-in code"}
                      leadingIcon={
                        <ProfileOutlined size="xx-small" variant="subtle" />
                      }
                      error={"Enter sign-in code"}
                      testId={"input-student-signin-code"}
                      autoFocus={true}
                    />
                  </div>
                  <Button
                    variant={"destructive"}
                    disabled={code.length == 0}
                    onClick={this.onSubmitClick}
                    size={"large"}
                    className={classes.submitButton}
                    testId={"student-sign-in"}
                    aria-label="Submit sign in code"
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </>
          ) : null}
        </div>
        <div>
          {renderTradeMarkText({
            align: "left",
          })}
        </div>
      </div>
    );
  }
}

export default StudentLogin;
